export const BAYER_2 = [
  [0, 2],
  [3, 1],
];
